
import { Options, Prop, Watch } from "vue-property-decorator";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import { mixins } from "vue-class-component";
import {
  email,
  maxLength,
  minLength,
  required,
  requiredIf,
} from "@vuelidate/validators";
import Validation from "@/components/validation/Validation.vue";
// @ts-ignore
import uniqid from "uniqid";
import RandExp from "randexp";
import { TelephoneHelperMixin } from "@/mixins/TelephoneHelperMixin";
import { FormMixin } from "@/mixins/form/FormMixin";
import { invalidPhone } from "@/validation/validators";
import { Ref } from "vue";
import { isUndefined } from "lodash";
import { namespace } from "vuex-class";
import { Router } from "vue-router";
import Spinner from "@/components/Spinner.vue";

const UserModule = namespace("users");
@Options({
  components: {
    Spinner,
    DefaultLayout,
    Validation,
  },
  validations() {
    return {
      salutation: { minLength: minLength(2) },
      email: { required, email: email },
      username: { required, minLength: minLength(4) },
      password: {
        required: (val: any, data: any) => {
          return data.item || val;
        },
        minLength: minLength(8),
      },
      firstName: { minLength: minLength(2) },
      lastName: { minLength: minLength(2) },
      street: { minLength: minLength(4) },
      zipCode: { minLength: minLength(5), maxLength: maxLength(5) },
    };
  },
})
export default class UserProfile extends mixins(
  FormMixin,
  TelephoneHelperMixin
) {
  protected getResource = "api/get_my_profile";
  protected saveResource = "api/save_my_profile";
  @UserModule.Action("update")
  protected updateAction: any;

  @UserModule.Action("findOne")
  protected getItemAction: any;

  @UserModule.Action("resetSave")
  protected resetAction: any;

  @UserModule.Getter("getDataItem")
  protected item: any;

  @UserModule.Getter("getSuccess")
  protected success: any;

  @UserModule.Getter("getIsLoading")
  protected isLoading: any;

  private salutation: string | null = null;
  private email?: string | null = null;
  private username?: string | null = null;
  private password?: string | null = null;
  private firstName?: string | null = null;
  private lastName?: string | null = null;
  private street?: string | null = null;
  private zipCode?: string | null = null;
  private city?: string | null = null;
  private region?: string | null = null;
  private country?: string | null = null;
  private phone?: string | null = null;
  private fax?: string | null = null;
  private department?: string | null = null;
  private company?: string | null = null;
  private webSite?: string | null = null;

  public salutations = ["Herr", "Frau"];

  private generateNewPassword() {
    this.password = this.generateRandomPassword();
  }

  private generateRandomPassword(): string {
    const strongRegex = new RegExp("[a-z0-9A-Z!@#\\\\$%\\\\^&\\\\*]{8,10}");
    const randexp = new RandExp(strongRegex);
    return randexp.gen();
  }

  private onSubmit(): void {
    if (this.isInvalidate()) {
      return;
    }
    const item: any = {
      salutation: this.salutation,
      email: this.email,
      username: this.username,
      firstName: this.firstName,
      lastName: this.lastName,
      street: this.street,
      zipCode: this.zipCode,
      city: this.city,
      region: this.region,
      country: this.country,
      company: this.company,
      department: this.department,
      phone: this.phone,
      fax: this.fax,
      webSite: this.webSite,
    };
    if (this.item?.id) {
      item.id = this.item.id;
      if (this.password) {
        item.password = this.password;
      }
    } else {
      item.password = this.password;
    }
    this.updateAction({
      resource: this.saveResource,
      data: item,
    });
  }

  @Watch("item", { immediate: true, deep: true })
  private onUserChange(item: any): void {
    if (item?.id) {
      this.salutation = item?.salutation;
      this.email = item.email;
      this.username = item.username;
      this.firstName = item.firstName;
      this.lastName = item.lastName;
      this.street = item.street;
      this.city = item.city;
      this.region = item.region;
      this.country = item.country;
      this.phone = item.phone;
      this.fax = item.fax;
      this.company = item.company;
      this.department = item.department;
      this.zipCode = item.zipCode;
      this.password = null;
      this.webSite = item.webSite;
    } else {
      if (!item?.password) {
        this.generateNewPassword();
      }
    }
  }
  @Watch("$route", { immediate: true, deep: true })
  protected routeChanged(router: Router) {
    this.getItemAction({
      resource: this.getResource,
    });
  }
}
